'use client';

import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { useEffect, useState } from 'react';
import { FaFacebook, FaRegEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { IoIosLink } from 'react-icons/io';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';

interface BlogHeaderProps {
  title: string;
}

export function BlogShare({ title }: BlogHeaderProps) {
  const { t } = useTranslations();

  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const socialsToShare = [
    {
      name: 'Facebook',
      icon: <FaFacebook size={20} className="text-black" />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    },
    {
      name: 'X',
      icon: <FaXTwitter size={20} className="text-black" />,
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`,
    },
    {
      name: 'Copy',
      icon: <IoIosLink size={20} className="text-black" />,
      onClick: () => {
        navigator.clipboard.writeText(currentUrl);
        toast({
          variant: 'success',
          title: t('text3117'),
        });
      },
    },
    {
      name: 'Email',
      icon: <FaRegEnvelope size={20} className="text-black" />,
      url: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(currentUrl)}`,
    },
  ];

  return (
    <div className="flex flex-col items-start justify-start gap-2.5 sm:flex-row sm:items-center sm:justify-end">
      <p className="text-sm font-bold text-black sm:text-base">{t('text1155')}:</p>
      <div className="flex items-center gap-2.5">
        {socialsToShare.map(social => (
          <ShareButton social={social} key={social.name} />
        ))}
      </div>
    </div>
  );
}

function ShareButton({
  social,
}: {
  social: {
    name: string;
    icon: React.ReactNode;
    url?: string;
    onClick?: () => void;
  };
}) {
  return social.url ? (
    <Link
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'flex min-h-14 min-w-14 items-center justify-center bg-black/10 transition-all hover:bg-black/40',
      )}
    >
      {social.icon}
    </Link>
  ) : (
    <div
      onClick={social.onClick}
      className={cn(
        'flex min-h-14 min-w-14 cursor-pointer items-center justify-center bg-black/10 transition-all hover:bg-black/40',
      )}
      aria-label={social.name}
    >
      {social.icon}
    </div>
  );
}
